import { ApplicationBracketsIcon } from './ApplicationBracketsIcon';

/**
 * author: Michael Richins
 * id 86A1CD17-B112-46F8-A076-424D528A25AA
 * name application-brackets
 * version: 3.2.89
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/application-brackets.svg
 * tags
 * - Developer / Languages 
 */
export const IframeBracketsIcon = ApplicationBracketsIcon;
export default IframeBracketsIcon